import * as React from 'react';

import './CreateList.scss';
import Alert from 'src/components/common/Alert';
import { whiteSpacesValidation as hasWhiteSpaces } from 'src/utils/whiteSpacesValidation';

interface ICreateListProps {
  onClose: () => void;
  onCreate: (name: string) => void;
  t?: any;
}

interface ICreateListState {
  name: string;
  isInvalidName: boolean;
}

class CreateList extends React.Component<ICreateListProps, ICreateListState> {
  constructor(props: any) {
    super(props);

    this.state = {
      name: '',
      isInvalidName: false
    };
  }

  private handleChangeName = (e: any) => {
    this.setState({ name: e.target.value, isInvalidName: false });
  };

  private handleCreateList = () => {
    if (!hasWhiteSpaces(this.state.name)) {
      this.props.onCreate(this.state.name);
    } else {
      this.setState({
        isInvalidName: true,
        name: ''
      });
    }
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-create-list">
        {this.state.isInvalidName && (
          <Alert
            styleClass="rp-lists-alert"
            message={t('myFavourites.enterNameError')}
            icon={'rpds-error'}
            handleCloseAlert={() => {
              return;
            }}
            type={'error'}
          />
        )}
        <div className="rp-create-list-wrapper">
          <span className="rpds-close" onClick={this.props.onClose} />
          <div className="rp-create-list--form">
            <div className="rp-create-list--title">
              {t('myFavourites.createNewList')}
            </div>
            <input
              className="rp-create-list--input"
              placeholder={t('myFavourites.nameYourList')}
              value={this.state.name}
              onChange={this.handleChangeName}
            />
          </div>
          <div className="rp-create-list--form">
            <button
              className="secondary-button rp-create-list--button"
              onClick={this.props.onClose}
            >
              {t('common.cancel')}
            </button>
            <button
              className="primary-button rp-create-list--button"
              onClick={this.handleCreateList}
            >
              {t('common.create')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateList;
